const useAuth = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser && Object.keys(currentUser)?.length;
};

export default useAuth;
